import React from 'react'
import { Spinner } from '@dostavkee/web-ui'

import styles from './total-count.module.scss'

type TotalCountProps = {
    count: number | undefined
}

export const TotalCount: React.FC<TotalCountProps> = ({ count }) => {
    return (
        <span className={styles['total-count']}>
            {typeof count === 'number' ? count : <Spinner size='small' />}
        </span>
    )
}
